import '../../monitoring/filters/date/applied_date_view.js.coffee'

Namespace 'Surveys.Views.Filters'

class Surveys.Views.Filters.AppliedSurveyAnswerDateView extends Monitoring.Views.SocialContents.Filters.AppliedDateView

  initialize: ({searchQuery, title}) ->
    super({searchQuery: searchQuery})
    @title = title || I18n.t('surveys.dashboard.filters.answered_at')
